import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import CustomText, { textStyles } from "../../components/CustomText";
import FeatureImageCard from "../../components/cards/FeatureImageCard";
import visualimage1 from "../../assets/visualimage1.svg";
import visualimage2 from "../../assets/visualimage2.svg";
import visualimage3 from "../../assets/visualimage3.svg";
import visualimage4 from "../../assets/visualimage4.svg";
import GetAppButton from "../../components/GetAppButton";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import more from "../../assets/more.svg";
import featuresheroimage from "../../assets/featuresheroimage.webp";
import featuresheroimageen from "../../assets/featuresheroimageen.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../components/BASE_URL";

// 🔹 Skeleton Loader
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useSocialLinks } from "../../components/fetchGetAppUrl";
const VisualImageSection = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  const hero_section_button_text = {
    main: "var(--Tertiary, #003149)",
    hover: "#00263a",
    contrastText: "#FFFFFF",
    fontSize: "18px",
  };

  // ✅ Local static images for cards
  const cardData = [
    {
      icon: <img src={visualimage1} alt="Icon 1" />,
    },
    {
      icon: <img src={visualimage2} alt="Icon 2" />,
    },
    {
      icon: <img src={visualimage3} alt="Icon 3" />,
    },
    {
      icon: <img src={visualimage4} alt="Icon 4" />,
    },
  ];

  const heroImageSrc =
    i18n.language === "es" ? featuresheroimage : featuresheroimageen;

  // 🔹 API State
  const [oversightData, setOversightData] = useState({
    title: "",
    description: "",
    list: [],
  });
  const [loading, setLoading] = useState(true);
  const { links } = useSocialLinks();

useEffect(() => {
  async function loadOversight() {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Home_Features_OverSights`
      );
      const json = await res.json();

      const section = (json?.data || []).find(
        (s) => s?.name?.trim().toLowerCase() === "home_features_oversights"
      );

      if (section?.items?.length) {
        const selectedItem =
          i18n.language === "es"
            ? section.items.find((item) => item.idx === 1)
            : section.items.find((item) => item.idx === 0);

        const parsedList = Array.isArray(selectedItem?.list)
          ? selectedItem.list
          : selectedItem?.list
            ? JSON.parse(selectedItem.list)
            : [];

        setOversightData({
          title: selectedItem?.title || "",
          description: selectedItem?.description || "",
          list: parsedList,
        });
      }
    } catch (err) {
      console.error("Error loading oversight features:", err);
    } finally {
      setLoading(false);
    }
  }

  loadOversight();
}, [i18n.language]);



  const handleMore = () => {
    navigate("/product-tour");
  };

  return (
    <Box
      sx={{
        backgroundColor: "#003149",
        px: isMobile ? 2 : 12,
        py: isMobile ? 6 : 10,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 3,
        }}
      >
        {/* 🔹 Left: Heading + Description */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <CustomText
            style={{
              ...textStyles.h3,
              color: "#ffffff",
              textAlign: "left",
              marginBottom: "1rem",
              fontSize: "43px",
              fontWeight: 600,
            }}
          >
            {loading ? <Skeleton width={400} height={50} /> : oversightData.title}
          </CustomText>

          <CustomText
            style={{
              ...textStyles.body2,
              color: "#D6D6D6",
              textAlign: "left",
              marginBottom: "20px",
              maxWidth: "85%",
              fontSize: "22px",
              letterSpacing: "1px",
            }}
          >
            {loading ? (
              <Skeleton width={600} height={20} count={3} />
            ) : (
              oversightData.description
            )}
          </CustomText>

          {/* Buttons */}
          <Box
            sx={{
              display: "flex",
              flexWrap: isMobile ? "wrap" : "nowrap",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              mt: 0,
              gap: 2,
            }}
          >
            <GetAppButton
              label={t("get_app_now")}
              variant="primary"
              size={i18n.language === "es" ? "medium" : "large"}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 0.5,
                border: "1px solid   #ffffff",
                borderRadius: "4.34px",
                padding: "8px 10px 8px 10px",
                height: "52px",
                cursor: "pointer",
              }}
              onClick={handleMore}
            >
              <img
                src={more || "/placeholder.svg"}
                style={{ width: "46px", height: "46px" }}
                alt="learn more"
              />
              <p
                style={{
                  color: "#ffffff",
                  fontSize: "18px",
                  fontWeight: 500,
                  fontFamily: "Poppins, sans-serif",
                  cursor: "pointer",
                }}
              >
                {t("learn_more")}
              </p>
            </Box>
          </Box>
        </Box>

        {/* 🔹 Right: Cards with static images + API list */}
        <Box sx={{ flex: 1 }}>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            {loading
              ? Array.from({ length: 4 }).map((_, i) => (
                  <Box key={i} sx={{ width: { xs: "100%", sm: "47%" } }}>
                    <Skeleton height={180} />
                  </Box>
                ))
              : oversightData.list.map((feature, index) => (
                  <Box
                    key={index}
                    sx={{
                      width: { xs: "100%", sm: "47%" },
                      boxSizing: "border-box",
                      transform: {
                        xs: "none",
                        sm: index === 1 ? "rotate(-5deg)" : "none",
                      },
                      position: {
                        xs: "static",
                        sm: index === 1 ? "relative" : "static",
                      },
                      bottom: { xs: "0px", sm: index === 1 ? "63px" : "0px" },
                      left: { xs: "0px", sm: index === 1 ? "20px" : "0px" },
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <FeatureImageCard
                      icon={cardData[index]?.icon}
                      title={feature.name}
                      description={feature.value}
                      variant="dark"
                    />
                  </Box>
                ))}
          </Box>
        </Box>
      </Box>

      {/* 🔹 Bottom Hero Image */}
      <Box>
        {loading ? (
          <Skeleton height={300} width={"90%"} />
        ) : (
          <img
            src={heroImageSrc}
            style={{
              marginTop: "30px",
              width: "90%",
              height: "90%",
              objectFit: "contain",
            }}
            alt="hero"
          />
        )}
      </Box>
    </Box>
  );
};

export default VisualImageSection;




